import { useGetData, useUpdateDataMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";
import useOCPFeeTypes from "./useOCPFeeTypes";

const OCPFeeTypes = () => {
  const { columns } = useOCPFeeTypes();

  const masterHook = useMasterModule({
    queryKey: "fee-types",
    idKey: "feeTypeId",
    nameKey: "feeName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useUpdateDataMutation,
    module: "fee-types",
    isCommunityQuery: true,
    hideDesc: true,
    statusSuccessMessage: "Fee Type Updated Successfully",
  });

  return <MasterModuleLayout title="Fee Types" hookResult={masterHook} extraColumns={columns} />;
}

export default OCPFeeTypes;